import { useWeb3Modal } from "@web3modal/wagmi/react"
import React, { useState, useCallback } from "react"
import { useAccount, useNetwork } from "wagmi"
import { Button, ButtonColor } from "~/components/shared/Button/Button"
import { toNFT } from "~/helpers/helpers"
import { supportedChains, mainconfig } from "~/config"
import ConnectModal from "../ConnectModal/ConnectModal"
import { useToast } from "~/helpers/hooks/useToast"
import { ampli, track } from "~/helpers/amplitude"
import { classNames } from "~/tools/classNames"
import cls from "./ConnectButton.module.scss"
import { ButtonSize } from "../../../shared/Button/Button"

function Account({ header }) {
    const { dismissAll } = useToast()
    return header ? (
        <div
            className="disabledChild"
            onClick={() => {
                toNFT()
            }}
        >
            <w3m-account-button
                balance={false}
                onClick={() => {
                    dismissAll()
                }}
            />
        </div>
    ) : (
        <div>
            <w3m-account-button
                onClick={() => {
                    dismissAll()
                }}
            />
        </div>
    )
}

function Chain() {
    const { dismissAll } = useToast()

    return <w3m-network-button onClick={() => dismissAll()} />
}

function ConnectButton(props) {
    const { action, connect, header, className, full, mint, headerStyle } = props

    const mods = {
        [cls.connect]: connect,
        [cls.mint]: mint
    }
    const { open } = useWeb3Modal()
    const { isConnected } = useAccount()
    const { chain } = useNetwork()
    const { isMetaMask } = mainconfig
    const { isMobile } = mainconfig

    const [connectModal, setConnectModal] = useState(false)
    const onCloseModal = useCallback(() => {
        setConnectModal(false)
        track(ampli.closeModal)
    }, [])
    return isConnected ? (
        <div {...props} className={`${cls.connected} ${header || headerStyle ? "" : cls.noHeader} ${className || ""}`}>
            {isMetaMask && header === false && supportedChains.includes(chain.id) && <Chain />}
            {!isMetaMask && header === false && supportedChains.includes(chain.id) && <Chain />}

            <Account header={header} />
        </div>
    ) : (
        <>
            <Button
                className={classNames(cls.ConnectButton, mods, [className])}
                header={header}
                color={ButtonColor.pink}
                size={full ? ButtonSize.full : null}
                onClick={() => {
                    if (action) {
                        action()
                    }
                    if (isMobile && !isMetaMask) {
                        setConnectModal(true)
                    } else {
                        open()
                    }
                }}
            >
                Connect Wallet
            </Button>
            {connectModal && <ConnectModal isOpen={connectModal} onClose={onCloseModal} />}
        </>
    )
}
export default React.memo(ConnectButton)
